import I18n from './i18n'
import Vue from 'vue'
import { detectedCulture } from '@/utilities/common/culture'
import router from '@/router'

const i18n = I18n.getInstance()

export default function install (Vue) {
  Vue.t = function (key, options) {
    return i18n.translate(key, options)
  }

  Vue.prototype.$t = function (key, options) {
    return i18n.translate(key, options)
  }

  Vue.i18next = i18n.i18next
}

export async function loadLolization () {
  try {
    if (detectedCulture.code === 'en-ca') {
      const query = router.history.current.query
      const cultureCode = query.shopperLocale && query.shopperLocale.replace('_', '-').toLowerCase()
      const languageCode = cultureCode || detectedCulture.code
      const canadaLanguage = window.localStorage.getItem('canadaLanguage')
      window.localStorage.setItem('cultureCode', languageCode)
      const { results: [{ data }] } = await Vue.prototype.$prismic.client.query(
        Vue.prototype.$prismic.Predicates.at('document.type', 'localization'),
        { lang: canadaLanguage || languageCode }
      )
      const localizationData = Object.entries(data).reduce((acc, [group, array]) => ({
        ...acc,
        ...array.reduce((acc, { key, value }) => ({
          ...acc,
          [`${group}.${key}`]: value
        }), {})
      }), {})
      i18n.i18next.addResourceBundle('localization', 'app', localizationData, true, true)
      window.localStorage.setItem('commonPageTitle', Vue.prototype.$t('common.pageTitle'))
      if (!/checkout|cart/i.test(window.location.pathname)) {
        document.title = Vue.prototype.$t('common.pageTitle', 'philips-subscription')
      }

    } else {
      const query = router.history.current.query
      const cultureCode = query.shopperLocale && query.shopperLocale.replace('_', '-').toLowerCase()
      const languageCode = cultureCode || detectedCulture.code
      const belgiumLanguage = window.localStorage.getItem('belgiumLanguage')
      window.localStorage.setItem('cultureCode', languageCode)
      const { results: [{ data }] } = await Vue.prototype.$prismic.client.query(
        Vue.prototype.$prismic.Predicates.at('document.type', 'localization'),
        { lang: belgiumLanguage || languageCode }
      )
      const localizationData = Object.entries(data).reduce((acc, [group, array]) => ({
        ...acc,
        ...array.reduce((acc, { key, value }) => ({
          ...acc,
          [`${group}.${key}`]: value
        }), {})
      }), {})
      i18n.i18next.addResourceBundle('localization', 'app', localizationData, true, true)
      window.localStorage.setItem('commonPageTitle', Vue.prototype.$t('common.pageTitle'))
      if (!/checkout|cart/i.test(window.location.pathname)) {
        document.title = Vue.prototype.$t('common.pageTitle', 'philips-subscription')
      } 
  }
  } catch (e) {
    console.error(e)
  }
}
